import * as React from 'react';
import '../css/login.css';
import { Input, Form } from 'semantic-ui-react';
import OAuth, { OAuthClientStatus } from '../api';

class State {
    username: string;
    password: string;
    newPwd: string;
    verifyPwd: string;
    loginError ?: string;
}

class Props {
    compactHardware: boolean;
}

export default class LoginView extends React.Component<Props, State> {
    private timer: any;

    componentWillMount() {
        this.setState({
            password: '',
            username: '',
            newPwd: '',
            verifyPwd: ''
        });
    }

    render() {
        const { username, password, newPwd, verifyPwd, loginError } = this.state;
        return (
            <div className="loginPage">
                <OAuth.Context>{(oauth: OAuthClientStatus) => (
                    <div className="login">
                        <div className="log-form">
                            <h2 className={(this.props.compactHardware) ? 'compact-h2' : 'active-h2'}>&nbsp;</h2>
                            <div className="rspMsg" id="messageBox">
                                {loginError &&
                                    <div className="errorMsg">
                                        <span
                                            className="floatLeft"
                                        >
                                            &#x2718;
                                        </span>
                                        {(typeof loginError === 'string') ? loginError : 'Invalid User Name or Password'}
                                    </div>
                                }
                            </div>
                            <Form>
                                <Form.Group>
                                <Input
                                    className="log-Form-input"
                                    placeholder="Username"
                                    type="text"
                                    value={username}
                                    autoFocus
                                    onChange={(event, data) => this.setState({username: data.value})}
                                />
                                </Form.Group>
                                <Form.Group>
                                <Input
                                    className="log-Form-input"
                                    placeholder="Password"
                                    type="password"
                                    value={password}
                                    onChange={(event, data) => this.setState({password: data.value})}
                                />
                                </Form.Group>
                                {loginError === 'Password Expired' &&
                                <Form.Group>
                                    <Input
                                        className="log-Form-input"
                                        placeholder="New Password"
                                        type="password"
                                        value={newPwd}
                                        onChange={(event, data) => this.setState({newPwd: data.value})}
                                    />
                                </Form.Group>
                                }
                                {loginError === 'Password Expired' &&
                                <Form.Group>
                                    <Input
                                        className="log-Form-input"
                                        placeholder="Verify Password"
                                        type="password"
                                        value={verifyPwd}
                                        onChange={(event, data) => this.setState({verifyPwd: data.value})}
                                    />
                                </Form.Group>
                                }
                                {loginError === 'Password Expired' &&
                                <input
                                    type="submit"
                                    name="reset"
                                    value={'Reset Password'}
                                    className="btn"
                                    disabled={Boolean(password.length === 0 || newPwd !== verifyPwd)}
                                    onClick={() => {
                                        // @ts-ignore
                                        oauth.updateUserPwd(username, password, newPwd)
                                            .then(() => {
                                                oauth.signInUsingClientCredentials(username, newPwd)
                                                    .catch((status: OAuthClientStatus) => {
                                                        if (status) {
                                                            this.setState({password: '', newPwd: '', verifyPwd: '', loginError: status.loginError});
                                                            if (this.timer) clearTimeout(this.timer);
                                                            this.timer = setTimeout(() => this.setState({loginError: undefined}), 5000);
                                                        } else
                                                            this.setState({
                                                                password: '',
                                                                loginError: 'Invalid User Name or Password'
                                                            });
                                                    });
                                            })
                                            .catch((status: OAuthClientStatus) => {
                                                if (status.loginError === 'access_denied') {
                                                    this.setState({password: '', newPwd: '', verifyPwd: '', loginError: 'Invalid User Name or Password'});
                                                    if (this.timer) clearTimeout(this.timer);
                                                    this.timer = setTimeout(() => this.setState({loginError: undefined}), 5000);
                                                } else
                                                    this.setState({
                                                    password: '',
                                                    loginError: 'Invalid User Name or Password'
                                                });
                                            });
                                        }}
                                />
                                }
                                {loginError !== 'Password Expired' &&
                                <input
                                    type="submit"
                                    name="login"
                                    value="Login"
                                    className="btn"
                                    onClick={() => {
                                        oauth.signInUsingClientCredentials(username, password)
                                            .catch((status: OAuthClientStatus) => {
                                                if (status) {
                                                    if (status.loginError === 'password_expired') {
                                                        this.setState({password: '', loginError: 'Password Expired'});
                                                        if (this.timer) clearTimeout(this.timer);
                                                    } else {
                                                        this.setState({password: '', loginError: status.loginError});
                                                        if (this.timer) clearTimeout(this.timer);
                                                        this.timer = setTimeout(() => this.setState({loginError: undefined}), 5000);
                                                    }
                                                } else
                                                    this.setState({
                                                        password: '',
                                                        loginError: 'Invalid User Name or Password'
                                                    });
                                            });
                                    }}
                                />
                                }
                            </Form>
                            <div className="footer">&nbsp;</div>
                        </div>
                    </div>
                )}</OAuth.Context>
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/login.tsx